/**
 * Application nav section component.
 */
import angular from 'angular';
import ComponentsModule from '../components-module';
import template from './code-app-nav.html';
import Debug from 'ace-ui/ace-debug';


const COMPONENT_NAME = 'codeAppNav';
const debug = new Debug (COMPONENT_NAME);

angular.module (ComponentsModule)
  .directive (COMPONENT_NAME, ($location, $route, TemplateService, RecentContentService, KeyboardShortcutService, ErrorMessagingService) => {
    function getTypeNames (templates) {
      return templates.reduce(function (arr, template) {
        if (arr.indexOf(template.type) === -1) {
          arr.push(template.type);
        }
        return arr;
      }, []);
    }

    return {
      restrict: 'AE',
      replace: false,
      scope: {},
      template,

      controller: function ($scope) {
        $scope.templates = [];
        $scope.knownTypes = [];
        $scope.isLoading = false;
        $scope.error = undefined;
        $scope.dropdownIsOpen = false;
        $scope.keyboardShortcut = KeyboardShortcutService.inferUserKey ('mod+k');

        $scope.browseAll = () => {
          var oldPath = $location.url();
          var newPath = '/search?q=*';

          debug.log ('browseAll', oldPath, newPath);

          if (oldPath == newPath) {
            debug.log ('reload');
            $route.reload();
          } else {
            debug.log ('location');
            $location.url(newPath);
          }
        };

        $scope.openRecentContent = function openRecentContent () {
          RecentContentService.showRecentContentDialog();
        };

        $scope.repopulateTemplateList = function repopulateTemplateList () {
          $scope.isLoading = true;

          TemplateService.getQuickCreatorTemplates('Create')
            .then (function (templates) {
              $scope.templates = templates;
              if ($scope.templates.length === 0) {
                console.warn('No templates with create permissions found!');
              }
            })
            .then (function () {
              return TemplateService.getTemplates('Read');
            })
            .then (function (templates) {
              $scope.knownTypes = getTypeNames(templates);
            })
            .catch (function (error) {
              ErrorMessagingService.sendError(atex.aceui.error.Error({
                type: atex.aceui.error.types.RUNTIME,
                severity: atex.aceui.error.severities.CRITICAL,
                origin: COMPONENT_NAME,
                cause: 'Error while loading content templates for the create menu in the app nav',
                rootCause: error
              }));
            })
            .finally (function () {
              $scope.isLoading = false;
            });
        };

        $scope.$on('aceui:userLoggedOut', function () {
          $scope.templates = [];
          TemplateService.reset();
        });

        $scope.$on('aceui:authenticationSuccess', function () {
          $scope.repopulateTemplateList();
        });
      },

      link: function (scope) {
        scope.repopulateTemplateList();
      }
    };
  });

export default COMPONENT_NAME;